export const normalizeDeviceList = (deviceList) => {
  return (
    deviceList?.map((device) => {
      return {
        currentDevice: device?.current_device ?? false,
        deviceId: device?.device_id ?? '',
        deviceName: device?.device_name ?? '',
        profile: {
          name: device?.profile_name ?? '',
          id: device?.profile_id ?? '',
        },
        usedDate: device?.used_date ?? '',
        loginDate: device?.login_date ?? '',
      }
    }) ?? []
  )
}

export const normalizeDevicesHistory = (rawData) => {
  return {
    loginDeviceTotalCount: rawData?.login_device_total_count ?? 0,
    deviceList: normalizeDeviceList(rawData?.device),
    offset: rawData?.offset ?? 0,
    limit: rawData?.limit ?? 30,
    totalPage: rawData?.total_page ?? 0,
    totalCount: rawData?.total_count ?? 0,
    currentPage: rawData?.current_page ?? 1,
  }
}
